(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery--default"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    let thumbSwiper = document.querySelector('.product__media-wrapper [data-thumbnail-slider]');
    let gallerySwiper = document.querySelector('.product__media-wrapper [data-gallery-slider]');
    let slideEffect = 'fade';
    let breakPoints = window.matchMedia('(max-width: 750px)');

    if (breakPoints.matches) {
      slideEffect = 'fade';
      gallerySwiper = document.querySelector('[data-gallery-slider]'); // slider is default for mobile screen
    }
    let thumbSwiperInit;
    if (thumbSwiper) {
      thumbSwiperInit = new Swiper(thumbSwiper, {
        slidesPerView: 6,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: 10,
        direction: 'vertical',
        navigation: {
          nextEl: '.mtc-col-slide-next',
          prevEl: '.mtc-col-slide-prev',
        },
        breakpoints: {
          992: {
            slidesPerView: 6,
            spaceBetween: 10,
          },
          750: {
            slidesPerView: 7,
            spaceBetween: 10,
          },
        },
      });
    }
    if (gallerySwiper) {
      let gallerySwiperInit = new Swiper(gallerySwiper, {
        effect: slideEffect,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        thumbs: {
          swiper: thumbSwiperInit ? thumbSwiperInit : null,
        },
        pagination: {
          el: '.product__holder-pagination',
        },
        on: {
          transitionStart: function () {
            const allVideos = [
              ...document.querySelectorAll('[data-gallery-slider] video, [data-gallery-slider] iframe'),
            ];
            if (allVideos.length) window.pauseAllMedia();
          },

          transitionEnd: function () {
            const activeIndex = this.activeIndex;
            const activeSlide = document.querySelectorAll('[data-gallery-slider] .swiper-slide')[activeIndex];
            const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
            if (activeSlideVideo) activeSlideVideo.play();
            //for external video
            const activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
            if (activeSlideIframe) {
              let iframeSrc = activeSlideIframe.getAttribute('src');
              if (iframeSrc.includes('?autoplay=0')) {
                let newSrc = iframeSrc.replace('?autoplay=0', '?autoplay=1&muted=1');
                activeSlideIframe.setAttribute('src', newSrc);
              }
              if (iframeSrc.includes('vimeo.com')) {
                activeSlideIframe.contentWindow.postMessage('{"method":"play"}', '*');
              } else {
                activeSlideIframe.contentWindow.postMessage(
                  '{"event":"command","func":"' + 'playVideo' + '","args":""}',
                  '*'
                );
              }
            }
          },
        },
      });
    }

    if (document.querySelector('variant-radios')) {
      document.querySelector('variant-radios').updateMedia();
    }

    const allWrappers = Array.from(document.querySelectorAll('.video-wrapper'));
    const childWrappers = allWrappers.filter((w) => w.closest('.child-grid'));
    let lastY = window.pageYOffset;
    const vh = () => window.innerHeight;
    function getActiveVideo(wrapper) {
      return Array.from(wrapper.querySelectorAll('video.video-element')).find(
        (v) => getComputedStyle(v).display !== 'none'
      );
    }

    // Setup child-grid videos
    childWrappers.forEach((wrapper) => {
      const video = getActiveVideo(wrapper);
      if (!video) return;
      video.muted = true;
      wrapper.__hasAutoPlayed = false;
    });

    function updatePlayIcons(wrapper, isPlaying) {
      const playI = wrapper.querySelector('.icon-play');
      const pauseI = wrapper.querySelector('.icon-pause');
      if (!playI || !pauseI) return;
      playI.style.display = isPlaying ? 'none' : 'block';
      pauseI.style.display = isPlaying ? 'block' : 'none';
    }
    function updateMuteIcons(wrapper, isMuted) {
      const muted = wrapper.querySelector('.icon-muted');
      const unmuted = wrapper.querySelector('.icon-unmuted');
      const btn = wrapper.querySelector('button.mute-button');
      if (!muted || !unmuted || !btn) return;
      muted.style.display = isMuted ? 'block' : 'none';
      unmuted.style.display = isMuted ? 'none' : 'block';
      btn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
    }

    // Manual play/pause + remove poster
    allWrappers.forEach((wrapper) => {
      const playBtn = wrapper.querySelector('button.play-button');
      const isChild = childWrappers.includes(wrapper);

      playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const video = getActiveVideo(wrapper);
        if (!video) return;

        if (video.paused) {
          if (isChild) video.muted = false;
          video.removeAttribute('poster');
          video.play();
          wrapper.classList.add('playing');
          updatePlayIcons(wrapper, true);
        } else {
          video.pause();
          wrapper.classList.remove('playing');
          updatePlayIcons(wrapper, false);
        }
      });

      if (isChild) {
        const muteBtn = wrapper.querySelector('button.mute-button');
        const video = getActiveVideo(wrapper);
        updateMuteIcons(wrapper, video.muted);
        muteBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          video.muted = !video.muted;
          updateMuteIcons(wrapper, video.muted);
        });
      }
      wrapper.querySelectorAll('video.video-element').forEach((video) => {
        video.addEventListener('ended', () => {
          wrapper.classList.remove('playing');
          updatePlayIcons(wrapper, false);
          video.currentTime = 0;
        });
      });
    });

    // Scroll-down auto-play once at 40%
    function onScroll() {
      const y = window.pageYOffset;
      const down = y > lastY;
      lastY = y;
      if (!down) return;

      const threshold = vh() * -0.2;
      childWrappers.forEach((wrapper) => {
        const video = getActiveVideo(wrapper);
        if (!video || wrapper.__hasAutoPlayed) return;
        const top = wrapper.getBoundingClientRect().top;
        if (top <= threshold) {
          video.removeAttribute('poster');
          video.play();
          wrapper.classList.add('playing');
          updatePlayIcons(wrapper, true);
          wrapper.__hasAutoPlayed = true;
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
  } catch(e) { console.error(e); }
})();

})();
